module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Remerciements")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("À MES")]), _vm._v(" bien-aimés Cinq, Penn, Tamm, Lea et Jenn. Vous avez toujours été mes étoiles à travers les épreuves, petites et grandes, les dangers inconnus et le reste. Vous êtes ma constellation et je n’oublierai jamais nos querelles et nos fous rires à propos du thé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Beaucoup d’affection et d’amour pour mes autres frères et sœurs, Ren, Ree, Mary et Lisa. Et bien sûr le San Diego Crewe – Andy, Steve, Maite et Felix.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Merci comme toujours à Dreamspinner – Elizabeth, Lynn, Naomi (qui endure ma folie), Liz et son équipe, tous ceux et celles qui travaillent si dur pour améliorer ce que je leur envoie. J’ai pour vous une infinie admiration.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Un hourra spécial à Micah Caudle qui me supporte. Mec, je te dois bien tout le café que tu ingurgiteras de ton vivant.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cb2de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0